import Toggle from "PFComponents/toggle/toggle";
import { RefObject } from "react";

import { useCommonProps } from "../use_common_props";

type BooleanCustomValueFieldProps = {
  commonProps: ReturnType<typeof useCommonProps>;
  isChecked: boolean;
  onChange: (value: boolean) => void;
  qaId: string;
  label?: string;
  switchRef?: RefObject<any>;
};

export const BooleanCustomValueField = ({
  commonProps,
  isChecked,
  onChange,
  qaId,
  label,
  switchRef
}: BooleanCustomValueFieldProps) => (
  <Toggle
    {...commonProps}
    readOnly={commonProps.locked}
    tip={commonProps.locked ? commonProps.lockedTip : commonProps.tip}
    checked={isChecked}
    onChange={onChange}
    qaId={qaId}
    label={label}
    switchRef={switchRef}
  />
);
